<template>
  <div
    data-testid="svg-sprite"
    style="display: none;"
  >
    <inline-svg
      width="0"
      height="0"
      :src="$options.SVG_ICONS_SPRITE_URL"
    />
  </div>
</template>

<script>
import InlineSvg from 'vue-inline-svg'
import { SVG_ICONS_SPRITE_URL } from 'Modules/constants'

export default {
  SVG_ICONS_SPRITE_URL,
  components: {
    InlineSvg
  }
}
</script>
